import { render, staticRenderFns } from "./HomeSidebar.vue?vue&type=template&id=1f6d2928&"
import script from "./HomeSidebar.vue?vue&type=script&lang=js&"
export * from "./HomeSidebar.vue?vue&type=script&lang=js&"
import style0 from "./HomeSidebar.vue?vue&type=style&index=0&id=1f6d2928&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports